import React from 'react'

import { useTranslation } from 'react-i18next'
import {
  GetTagModalContainer,
  GetTagModalDescription,
  GetTagModalContent,
} from './GetTagModal.styled'

import { GetTagMethods } from './components/GetTagMethods'
import {
  GetTagSection,
  ValidateTagSectionContent,
  GetTagSectionNumCircle,
  GetTagSectionTitle,
} from './components/GetTagMethods.styled'
import { ValidateTag } from 'Features/validateTag/components/ValidateTag'
import { TagMethods } from './components/RadioMethodsSelection/RadioMethodsSelection.models'
import { Domain } from 'Types/Domain'

type GetTagModalProps = {
  tagUrl?: string
  domainId: number
  domain?: Domain | undefined
  bzState?: number | null
  intitialMethod?: TagMethods
  domainAddress: string | undefined
  isWordpress?: boolean
  onOpenChange: (a: boolean) => void
  handleValidation?(): void
}

export const GetTagInner = ({
  tagUrl,
  bzState,
  isWordpress,
  domainAddress,
  intitialMethod,
  onOpenChange,
  handleValidation,
  domain,
  domainId,
}: GetTagModalProps) => {
  const { t } = useTranslation('domainManagement')

  const closeModal = () => {
    onOpenChange(false)
  }

  return (
    <GetTagModalContainer>
      <GetTagModalDescription>{t('get_tag_modal.description')}</GetTagModalDescription>
      <GetTagModalDescription>{t('get_tag_modal.sub_description')}</GetTagModalDescription>
      <GetTagModalContent>
        <GetTagMethods
          domain={domain || undefined}
          tagUrl={tagUrl || ''}
          closeModal={closeModal}
          bzState={bzState}
          initialMethod={intitialMethod}
          domainAddress={domainAddress}
          isWordpress={isWordpress}
        />
        <GetTagSection css={{ flex: 0.6 }}>
          <GetTagSectionTitle css={{ marginLeft: '40px' }}>
            <GetTagSectionNumCircle>3</GetTagSectionNumCircle>
            {t('get_tag_modal.title_validations')}
          </GetTagSectionTitle>
          <ValidateTagSectionContent>
            <ValidateTag
              domainId={domain?.id || domainId || 0}
              handleTagValidation={handleValidation}
            />
          </ValidateTagSectionContent>
        </GetTagSection>
      </GetTagModalContent>
    </GetTagModalContainer>
  )
}
